/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Processing_LabelInputs */



/**
* | output |
* | --- |
* | "Processing... please wait." |
*
* @param {Drastic_Tech_Processing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_processing_label = /** @type {((inputs?: Drastic_Tech_Processing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Processing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung läuft... Bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione in corso... attendere prego.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesando... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理中です...お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रक्रिया जारी है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processando... aguarde.")
	return /** @type {LocalizedString} */ ("Processing... please wait.")
});